import IGPostIcon from 'assets/icons/mono/IGPostIcon'
import IGStoryIcon from 'assets/icons/mono/IGStoryIcon'
import MediaCommentsIcon from 'assets/icons/mono/MediaCommentsIcon'
import MediaLikesIcon from 'assets/icons/mono/MediaLikesIcon'
import MediaViewsIcon from 'assets/icons/mono/MediaViewsIcon'
import ReelsIcon from 'assets/icons/ReelsIcon'
import InstagramCaption from 'Components/Common/InstagramCaption'
import SmartImage from 'Components/Common/SmartImage'
import React from 'react'
import { useDispatch } from 'react-redux'
import { showSocialPostModal } from 'slices/ui/reducer'
import { AppDispatch } from 'store'
import { SocialPost } from 'types/campaign/collaborations'
import { formatNumber, getTrimmedText } from 'utils/helpers'

const PostPreview: React.FC<{ post: SocialPost, showContentOverlay?: boolean, onHoverActions?: React.ReactNode, alwaysVisibleActions?: React.ReactNode }> = ({ post, onHoverActions, alwaysVisibleActions, showContentOverlay = true }) => {
    const dispatch: AppDispatch = useDispatch();
    return (
        <div className="cursor-pointer position-relative masonry-media" onClick={() => {
            dispatch(showSocialPostModal({ postId: post.uuid, socialAccount: post.social_account! }))
        }}>
            <SmartImage src={post.thumbnail_url} alt={post.posted_on} wrapperClass='explore-item' className='explore-thumb' />
            {
                showContentOverlay &&
                <div className="masonry-overlay flex-column justify-content-between align-items-start p-2">
                    <div>
                        {
                            post?.ig_post?.caption &&
                            <div className="post-card-caption" style={{ marginTop: '32px', width: '100%' }}>
                                <InstagramCaption text={getTrimmedText(post?.ig_post?.caption)} />
                            </div>
                        }
                    </div>
                    {
                        !!(onHoverActions) &&
                        <div className="position-absolute" style={{ right: '8px', top: '8px', left: 'none' }} onClick={(e) => e.stopPropagation()}>
                            {onHoverActions}
                        </div>
                    }
                    <div className="masonry-stats w-100 d-flex align-items-center justify-content-center">
                        <span className='d-flex align-items-center gap-1'><MediaViewsIcon /> {formatNumber(post.views_count ?? 0)}</span>
                        <span className='d-flex align-items-center gap-1'><MediaLikesIcon /> {formatNumber(post.likes_count ?? 0)}</span>
                        <span className='d-flex align-items-center gap-1'><MediaCommentsIcon /> {formatNumber(post.comments_count ?? 0)}</span>
                    </div>
                </div>
            }
            {
                !!(alwaysVisibleActions) &&
                <div className="position-absolute" style={{ right: '8px', top: '8px', left: 'none' }} onClick={(e) => e.stopPropagation()}>
                    {alwaysVisibleActions}
                </div>
            }
            <span className="media-type-icon" style={{ left: '8px', top: '8px' }}>
                {
                    post.type === 'REELS' &&
                    <ReelsIcon color="#ffffff" />
                }
                {
                    post.type === 'STORY' &&
                    <IGStoryIcon color='#ffffff' />
                }
                {
                    post.type === 'VIDEO' &&
                    <i className="ri-youtube-fill" style={{ fontSize: '24px', color: '#ffffff' }}></i>
                }
                {
                    !["REELS", "STORY", "VIDEO"].includes(post.type) &&
                    <IGPostIcon color='#ffffff' />
                }
            </span>

        </div>
    )
}

export default PostPreview